import React from "react";
import { motion } from "framer-motion";
import { WhatsAppCTA } from "../WhatsAppCTA";
import { fadeUp, viewport } from "../../lib/motion";
import { IMAGES } from "../../lib/site";

export const Transition = () => {
  return (
    <section
      data-testid="transition-section"
      className="relative bg-[#050505] py-32 md:py-48 overflow-hidden"
    >
      {/* Faint power icon (/logo_power.png) */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <img
          src={IMAGES.power}
          alt=""
          aria-hidden="true"
          className="opacity-[0.11] select-none"
          style={{ width: "min(360px, 55vw)", height: "auto" }}
        />
      </div>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={viewport}
        className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-12 text-center"
      >
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05]">
          <span className="block text-[#f5f5f7]">Quando seu celular para,</span>
          <span className="block text-[#86868b]">sua rotina também para.</span>
        </h2>

        <div className="mt-12 flex justify-center">
          <WhatsAppCTA label="Falar no WhatsApp" testId="transition-whatsapp" />
        </div>
      </motion.div>
    </section>
  );
};
